export default __webpack_public_path__ + "static/media/FinanceRealCase2-en.763d7861.jpg";